import { render, staticRenderFns } from "./RealEstateEvaluationBuildingEdit.vue?vue&type=template&id=db9a2588&scoped=true&"
import script from "./RealEstateEvaluationBuildingEdit.vue?vue&type=script&lang=js&"
export * from "./RealEstateEvaluationBuildingEdit.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateEvaluationBuildingEdit.vue?vue&type=style&index=0&id=db9a2588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9a2588",
  null
  
)

export default component.exports